module.exports = __webpack_public_path__ + "static/level_03_icon-86d16ea574202efd7efcfc9632144378.svg";